import { gql } from '@apollo/client';
import { MATERIAL_TEMPLATE_FIELDS } from './fragments';

// ============================================================================
// Queries
// ============================================================================

export const MATERIAL_TEMPLATES_QUERY = gql`
  query MaterialTemplates($allCustomers: Boolean, $customerNumbers: [String!]) {
    materialTemplates(allCustomers: $allCustomers, customerNumbers: $customerNumbers) {
      ...MaterialTemplateFields
    }
  }
  ${MATERIAL_TEMPLATE_FIELDS}
`;

export const MATERIAL_TEMPLATE_QUERY = gql`
  query MaterialTemplate($id: ID!, $allCustomers: Boolean, $customerNumbers: [String!]) {
    materialTemplate(id: $id, allCustomers: $allCustomers, customerNumbers: $customerNumbers) {
      ...MaterialTemplateFields
    }
  }
  ${MATERIAL_TEMPLATE_FIELDS}
`;

// ============================================================================
// Mutations
// ============================================================================

export const CREATE_MATERIAL_TEMPLATE_MUTATION = gql`
  mutation CreateMaterialTemplate(
    $name: String!
    $items: [MaterialTemplateItemInput!]!
    $customerNumber: String
  ) {
    createMaterialTemplate(name: $name, items: $items, customerNumber: $customerNumber) {
      ...MaterialTemplateFields
    }
  }
  ${MATERIAL_TEMPLATE_FIELDS}
`;

export const UPDATE_MATERIAL_TEMPLATE_MUTATION = gql`
  mutation UpdateMaterialTemplate(
    $id: ID!
    $name: String
    $items: [MaterialTemplateItemInput!]
    $accentColor: String
    $customerNumber: String
  ) {
    updateMaterialTemplate(
      id: $id
      name: $name
      items: $items
      accentColor: $accentColor
      customerNumber: $customerNumber
    ) {
      ...MaterialTemplateFields
    }
  }
  ${MATERIAL_TEMPLATE_FIELDS}
`;

export const DELETE_MATERIAL_TEMPLATE_MUTATION = gql`
  mutation DeleteMaterialTemplate($id: ID!, $customerNumber: String) {
    deleteMaterialTemplate(id: $id, customerNumber: $customerNumber)
  }
`;
